module.exports = __webpack_public_path__ + "img/1533515480.ec4c38bd.jpg";